export const positionListStatusMock = [
  {
    vesselId: '123abc',
    status: 'onboarding',
  },
]

export const mockVoyages = [
  {
    productCodes: 'ULSD, Ref, GO, UMS, Nap',
    blCodes: '',
    cargoGrades:
      'ULSD 10 PPM, REFORMATE, GAS OIL, GASOIL 0.1% SULPHUR, GASOIL, GASOLINE 98R SPULP, GASOLINE, NAPHTHA',
    ballastPort: 'JORF LASFAR',
    chartererShortName: 'CEPSATRADINGSAU_48168',
    commenceDate: '2024-03-01T16:30:00',
    CompleteDate: '2025-09-16T18:30:00',
    cpDate: null,
    dischargePort: 'TENERIFE',
    fixtureDate: '2024-03-01T00:00:00',
    itineraries: [
      {
        seq: 100,
        portName: 'JORF LASFAR',
        portFunction: 'COMMENCING',
        arrivalLocal: null,
        arrivalGmt: null,
        departureLocal: '2024-03-01T16:30:00',
        departureGmt: '2024-03-01T15:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 200,
        portName: 'JORF LASFAR',
        portFunction: 'DELIVERY',
        arrivalLocal: '2024-03-01T16:30:00',
        arrivalGmt: '2024-03-01T15:30:00',
        departureLocal: '2024-03-01T16:30:00',
        departureGmt: '2024-03-01T15:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 500,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-03-02T14:24:00',
        arrivalGmt: '2024-03-02T13:24:00',
        departureLocal: '2024-03-11T13:24:00',
        departureGmt: '2024-03-11T12:24:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GAS OIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 800,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-03-13T20:42:00',
        arrivalGmt: '2024-03-13T20:42:00',
        departureLocal: '2024-03-16T01:24:00',
        departureGmt: '2024-03-16T01:24:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 700,
        portName: 'SALINETAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-03-16T06:24:00',
        arrivalGmt: '2024-03-16T06:24:00',
        departureLocal: '2024-03-18T13:00:00',
        departureGmt: '2024-03-18T13:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1000,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-03-20T19:12:00',
        arrivalGmt: '2024-03-20T18:12:00',
        departureLocal: '2024-03-25T13:00:00',
        departureGmt: '2024-03-25T12:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1300,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-03-27T22:00:00',
        arrivalGmt: '2024-03-27T22:00:00',
        departureLocal: '2024-03-30T18:00:00',
        departureGmt: '2024-03-30T18:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1700,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-04-02T07:12:00',
        arrivalGmt: '2024-04-02T05:12:00',
        departureLocal: '2024-04-11T03:24:00',
        departureGmt: '2024-04-11T01:24:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1600,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-04-13T11:18:00',
        arrivalGmt: '2024-04-13T10:18:00',
        departureLocal: '2024-04-15T14:30:00',
        departureGmt: '2024-04-15T13:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1900,
        portName: 'ALGECIRAS',
        portFunction: 'LOADING',
        arrivalLocal: '2024-04-18T01:12:00',
        arrivalGmt: '2024-04-17T23:12:00',
        departureLocal: '2024-04-20T01:48:00',
        departureGmt: '2024-04-19T23:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 2100,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-04-22T10:00:00',
        arrivalGmt: '2024-04-22T09:00:00',
        departureLocal: '2024-04-25T22:54:00',
        departureGmt: '2024-04-25T21:54:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 2900,
        portName: 'ALGECIRAS',
        portFunction: 'LOADING',
        arrivalLocal: '2024-05-01T22:48:00',
        arrivalGmt: '2024-05-01T20:48:00',
        departureLocal: '2024-05-04T06:48:00',
        departureGmt: '2024-05-04T04:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 2800,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-05-06T17:24:00',
        arrivalGmt: '2024-05-06T16:24:00',
        departureLocal: '2024-05-12T14:18:00',
        departureGmt: '2024-05-12T13:18:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 3500,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-05-15T02:42:00',
        arrivalGmt: '2024-05-15T00:42:00',
        departureLocal: '2024-05-18T07:42:00',
        departureGmt: '2024-05-18T05:42:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 3400,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-05-20T16:42:00',
        arrivalGmt: '2024-05-20T15:42:00',
        departureLocal: '2024-05-23T14:48:00',
        departureGmt: '2024-05-23T13:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 3700,
        portName: 'BANCO DEL HOYO ANCHORAGE',
        portFunction: 'WAITING',
        arrivalLocal: '2024-05-26T01:30:00',
        arrivalGmt: '2024-05-25T23:30:00',
        departureLocal: '2024-05-28T13:48:00',
        departureGmt: '2024-05-28T11:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 4300,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-05-28T17:48:00',
        arrivalGmt: '2024-05-28T15:48:00',
        departureLocal: '2024-06-03T14:36:00',
        departureGmt: '2024-06-03T12:36:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 3900,
        portName: 'AMSTERDAM',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-06-07T08:12:00',
        arrivalGmt: '2024-06-07T06:12:00',
        departureLocal: '2024-06-15T10:00:00',
        departureGmt: '2024-06-15T08:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 4800,
        portName: 'ROTTERDAM',
        portFunction: 'LOADING',
        arrivalLocal: '2024-06-15T14:30:00',
        arrivalGmt: '2024-06-15T12:30:00',
        departureLocal: '2024-06-19T17:00:00',
        departureGmt: '2024-06-19T15:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 5100,
        portName: 'GOTHENBURG',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-06-21T10:30:00',
        arrivalGmt: '2024-06-21T08:30:00',
        departureLocal: '2024-06-24T07:18:00',
        departureGmt: '2024-06-24T05:18:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 5400,
        portName: 'FREDERICIA',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-06-24T19:36:00',
        arrivalGmt: '2024-06-24T17:36:00',
        departureLocal: '2024-06-27T15:12:00',
        departureGmt: '2024-06-27T13:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 6000,
        portName: 'GOTHENBURG',
        portFunction: 'FUELING',
        arrivalLocal: '2024-06-28T04:06:00',
        arrivalGmt: '2024-06-28T02:06:00',
        departureLocal: '2024-06-28T10:12:00',
        departureGmt: '2024-06-28T08:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 5700,
        portName: 'ROTTERDAM',
        portFunction: 'WAITING',
        arrivalLocal: '2024-06-30T05:36:00',
        arrivalGmt: '2024-06-30T03:36:00',
        departureLocal: '2024-07-23T14:30:00',
        departureGmt: '2024-07-23T12:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 6200,
        portName: 'LA CORUNA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-07-26T07:00:00',
        arrivalGmt: '2024-07-26T05:00:00',
        departureLocal: '2024-07-29T03:00:00',
        departureGmt: '2024-07-29T01:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOLINE 98R SPULP', 'GASOLINE', 'GASOIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 6100,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-08-01T08:00:00',
        arrivalGmt: '2024-08-01T07:00:00',
        departureLocal: '2024-08-04T14:48:00',
        departureGmt: '2024-08-04T13:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 6400,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-08-07T02:24:00',
        arrivalGmt: '2024-08-07T00:24:00',
        departureLocal: '2024-08-12T07:30:00',
        departureGmt: '2024-08-12T05:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 6500,
        portName: 'LIVORNO',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-08-15T18:24:00',
        arrivalGmt: '2024-08-15T16:24:00',
        departureLocal: '2024-08-18T10:00:00',
        departureGmt: '2024-08-18T08:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 6600,
        portName: 'GAETA',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-08-19T07:00:00',
        arrivalGmt: '2024-08-19T05:00:00',
        departureLocal: '2024-08-24T16:00:00',
        departureGmt: '2024-08-24T14:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7100,
        portName: 'CASTELLON DE LA PLANA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-08-26T21:30:00',
        arrivalGmt: '2024-08-26T19:30:00',
        departureLocal: '2024-08-28T14:30:00',
        departureGmt: '2024-08-28T12:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL 0.1% SULPHUR'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7300,
        portName: 'BARCELONA',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-08-28T23:59:00',
        arrivalGmt: '2024-08-28T21:59:00',
        departureLocal: '2024-08-30T20:30:00',
        departureGmt: '2024-08-30T18:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL 0.1% SULPHUR'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7400,
        portName: 'MALTA (COUNTRY)',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-09-02T00:48:00',
        arrivalGmt: '2024-09-01T22:48:00',
        departureLocal: '2024-09-03T22:30:00',
        departureGmt: '2024-09-03T20:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7500,
        portName: 'CASTELLON DE LA PLANA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-09-06T08:00:00',
        arrivalGmt: '2024-09-06T06:00:00',
        departureLocal: '2024-09-08T20:30:00',
        departureGmt: '2024-09-08T18:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL 0.1% SULPHUR'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7700,
        portName: 'ALGECIRAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-09-10T08:18:00',
        arrivalGmt: '2024-09-10T06:18:00',
        departureLocal: '2024-09-12T11:30:00',
        departureGmt: '2024-09-12T09:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7600,
        portName: 'CEUTA',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-09-12T12:06:00',
        arrivalGmt: '2024-09-12T10:06:00',
        departureLocal: '2024-09-13T09:30:00',
        departureGmt: '2024-09-13T07:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 7800,
        portName: 'BILBAO',
        portFunction: 'LOADING',
        arrivalLocal: '2024-09-17T06:00:00',
        arrivalGmt: '2024-09-17T04:00:00',
        departureLocal: '2024-09-19T15:42:00',
        departureGmt: '2024-09-19T13:42:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 8100,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-09-23T23:30:00',
        arrivalGmt: '2024-09-23T22:30:00',
        departureLocal: '2024-09-25T14:30:00',
        departureGmt: '2024-09-25T13:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 8200,
        portName: 'OFFSHORE GIBRALTAR',
        portFunction: 'WAITING',
        arrivalLocal: '2024-09-28T07:00:00',
        arrivalGmt: '2024-09-28T05:00:00',
        departureLocal: '2024-10-02T19:48:00',
        departureGmt: '2024-10-02T17:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 8300,
        portName: 'SINES',
        portFunction: 'LOADING',
        arrivalLocal: '2024-10-03T16:30:00',
        arrivalGmt: '2024-10-03T15:30:00',
        departureLocal: '2024-10-11T22:00:00',
        departureGmt: '2024-10-11T21:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['REFORMATE', 'NAPHTHA'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 8600,
        portName: 'VASSILIKO',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-10-20T02:12:00',
        arrivalGmt: '2024-10-19T23:12:00',
        departureLocal: '2024-10-27T13:12:00',
        departureGmt: '2024-10-27T11:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 8800,
        portName: 'VASSILIKO',
        portFunction: 'WAITING',
        arrivalLocal: '2024-10-27T13:12:00',
        arrivalGmt: '2024-10-27T11:12:00',
        departureLocal: '2024-10-31T16:12:00',
        departureGmt: '2024-10-31T14:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 8900,
        portName: 'AUGUSTA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-11-05T11:00:00',
        arrivalGmt: '2024-11-05T10:00:00',
        departureLocal: '2024-11-07T20:12:00',
        departureGmt: '2024-11-07T19:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9000,
        portName: 'JORF LASFAR',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-11-12T09:36:00',
        arrivalGmt: '2024-11-12T08:36:00',
        departureLocal: '2024-11-17T08:18:00',
        departureGmt: '2024-11-17T07:18:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9200,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-11-18T02:42:00',
        arrivalGmt: '2024-11-18T01:42:00',
        departureLocal: '2024-11-24T13:00:00',
        departureGmt: '2024-11-24T12:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9500,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-11-27T18:42:00',
        arrivalGmt: '2024-11-27T18:42:00',
        departureLocal: '2024-11-29T02:54:00',
        departureGmt: '2024-11-29T02:54:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9400,
        portName: 'SALINETAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-11-29T02:56:00',
        arrivalGmt: '2024-11-29T02:56:00',
        departureLocal: '2024-12-03T09:46:00',
        departureGmt: '2024-12-03T09:46:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9300,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-12-03T16:06:00',
        arrivalGmt: '2024-12-03T16:06:00',
        departureLocal: '2024-12-05T03:30:00',
        departureGmt: '2024-12-05T03:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9600,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-12-05T16:00:00',
        arrivalGmt: '2024-12-05T16:00:00',
        departureLocal: '2024-12-06T20:18:00',
        departureGmt: '2024-12-06T20:18:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9700,
        portName: 'HUELVA',
        portFunction: 'LOADING',
        arrivalLocal: '2024-12-09T08:30:00',
        arrivalGmt: '2024-12-09T07:30:00',
        departureLocal: '2024-12-17T23:12:00',
        departureGmt: '2024-12-17T22:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9800,
        portName: 'JORF LASFAR',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-12-18T19:30:00',
        arrivalGmt: '2024-12-18T18:30:00',
        departureLocal: '2024-12-24T11:30:00',
        departureGmt: '2024-12-24T10:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 10100,
        portName: 'ALGECIRAS',
        portFunction: 'LOADING',
        arrivalLocal: '2024-12-25T06:36:00',
        arrivalGmt: '2024-12-25T05:36:00',
        departureLocal: '2024-12-27T02:18:00',
        departureGmt: '2024-12-27T01:18:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 10000,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-12-29T12:30:00',
        arrivalGmt: '2024-12-29T12:30:00',
        departureLocal: '2025-01-07T17:12:00',
        departureGmt: '2025-01-07T17:12:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 9900,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-01-07T22:00:00',
        arrivalGmt: '2025-01-07T22:00:00',
        departureLocal: '2025-01-09T10:54:00',
        departureGmt: '2025-01-09T10:54:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 10400,
        portName: 'ANTWERP',
        portFunction: 'LOADING',
        arrivalLocal: '2025-01-15T02:30:00',
        arrivalGmt: '2025-01-15T01:30:00',
        departureLocal: '2025-01-19T22:00:00',
        departureGmt: '2025-01-19T21:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 10900,
        portName: 'CEUTA',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-01-24T19:30:00',
        arrivalGmt: '2025-01-24T18:30:00',
        departureLocal: '2025-01-25T21:30:00',
        departureGmt: '2025-01-25T20:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 11300,
        portName: 'TANGER MED',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-01-25T22:30:00',
        arrivalGmt: '2025-01-25T21:30:00',
        departureLocal: '2025-01-27T12:00:00',
        departureGmt: '2025-01-27T11:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 12100,
        portName: 'ALGECIRAS',
        portFunction: 'LOADING',
        arrivalLocal: '2025-02-01T16:30:00',
        arrivalGmt: '2025-02-01T15:30:00',
        departureLocal: '2025-02-05T17:00:00',
        departureGmt: '2025-02-05T16:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 12400,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-02-08T04:42:00',
        arrivalGmt: '2025-02-08T04:42:00',
        departureLocal: '2025-02-10T22:48:00',
        departureGmt: '2025-02-10T22:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 11800,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-02-11T03:54:00',
        arrivalGmt: '2025-02-11T03:54:00',
        departureLocal: '2025-02-12T11:42:00',
        departureGmt: '2025-02-12T11:42:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 12600,
        portName: 'TENERIFE',
        portFunction: 'REPAIR',
        arrivalLocal: '2025-02-12T16:18:00',
        arrivalGmt: '2025-02-12T16:18:00',
        departureLocal: '2025-02-15T22:36:00',
        departureGmt: '2025-02-15T22:36:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 12700,
        portName: 'ALGECIRAS',
        portFunction: "CHARTERER'S ORDERS",
        arrivalLocal: '2025-02-18T14:18:00',
        arrivalGmt: '2025-02-18T13:18:00',
        departureLocal: '2025-02-20T12:30:00',
        departureGmt: '2025-02-20T11:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 12900,
        portName: 'FAWLEY',
        portFunction: 'LOADING',
        arrivalLocal: '2025-02-24T18:30:00',
        arrivalGmt: '2025-02-24T18:30:00',
        departureLocal: '2025-03-04T18:00:00',
        departureGmt: '2025-03-04T18:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['GASOIL'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13100,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-03-11T07:00:00',
        arrivalGmt: '2025-03-11T07:00:00',
        departureLocal: '2025-03-13T19:42:00',
        departureGmt: '2025-03-13T19:42:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13200,
        portName: 'SINES',
        portFunction: 'LOADING',
        arrivalLocal: '2025-03-16T06:30:00',
        arrivalGmt: '2025-03-16T06:30:00',
        departureLocal: '2025-03-26T09:00:00',
        departureGmt: '2025-03-26T09:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13300,
        portName: 'BILBAO',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-03-28T20:12:00',
        arrivalGmt: '2025-03-28T19:12:00',
        departureLocal: '2025-04-01T06:30:00',
        departureGmt: '2025-04-01T04:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13400,
        portName: 'LA CORUNA',
        portFunction: 'LOADING',
        arrivalLocal: '2025-04-02T03:30:00',
        arrivalGmt: '2025-04-02T01:30:00',
        departureLocal: '2025-04-06T02:30:00',
        departureGmt: '2025-04-06T00:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13500,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-04-09T19:30:00',
        arrivalGmt: '2025-04-09T18:30:00',
        departureLocal: '2025-04-14T02:30:00',
        departureGmt: '2025-04-14T01:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13600,
        portName: 'ALGECIRAS',
        portFunction: 'LOADING',
        arrivalLocal: '2025-04-16T19:00:00',
        arrivalGmt: '2025-04-16T17:00:00',
        departureLocal: '2025-04-22T05:00:00',
        departureGmt: '2025-04-22T03:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 14000,
        portName: 'SALINETAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-04-24T15:00:00',
        arrivalGmt: '2025-04-24T14:00:00',
        departureLocal: '2025-04-30T10:00:00',
        departureGmt: '2025-04-30T09:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 13800,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-04-30T13:00:00',
        arrivalGmt: '2025-04-30T12:00:00',
        departureLocal: '2025-05-08T18:48:00',
        departureGmt: '2025-05-08T17:48:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 14100,
        portName: 'ALGECIRAS',
        portFunction: 'LOADING',
        arrivalLocal: '2025-05-11T23:30:00',
        arrivalGmt: '2025-05-11T21:30:00',
        departureLocal: '2025-05-14T10:30:00',
        departureGmt: '2025-05-14T08:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 14300,
        portName: 'SALINETAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-05-16T19:30:00',
        arrivalGmt: '2025-05-16T18:30:00',
        departureLocal: '2025-05-18T19:30:00',
        departureGmt: '2025-05-18T18:30:00',
        arrDepStatus: '..',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 14500,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2025-05-19T00:57:36',
        arrivalGmt: '2025-05-18T23:57:36',
        departureLocal: '2025-05-21T00:57:36',
        departureGmt: '2025-05-20T23:57:36',
        arrDepStatus: '..',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 400,
        portName: 'GIBRALTAR',
        portFunction: 'REDELIVERY',
        arrivalLocal: '2025-09-16T18:30:00',
        arrivalGmt: '2025-09-16T16:30:00',
        departureLocal: '2025-09-16T18:30:00',
        departureGmt: '2025-09-16T16:30:00',
        arrDepStatus: '..',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
    ],
    loadPort: 'HUELVA',
    status: 'Commenced',
    vesselCode: 'V198',
    voyageNumber: 24603,
    chtrCoordinatorInitials: 'AMO379',
    cargoGroup: '',
    lastUpdateGmt: '2025-05-15T06:54:01',
    operator: 'Isha Shah',
    distances: [
      {
        port_name: 'GIBRALTAR',
        latitude: 35.95,
        longitude: -5.7666666667,
        distance_naut: 0,
        ETA: '2025-09-16 18:30:00',
        UTC_ETA: '2025-09-16 16:30:00',
      },
      {
        port_name: 'HOUSTON',
        latitude: 29.75,
        longitude: -95.3333333333,
        distance_naut: 4733.986921992375,
        ETA: '2025-10-02 06:13:08',
        UTC_ETA: '2025-10-02 11:13:08',
      },
      {
        port_name: 'AMSTERDAM',
        latitude: 52.3666666667,
        longitude: 4.8833333333,
        distance_naut: 1468.5104284570282,
        ETA: '2025-09-21 15:58:51',
        UTC_ETA: '2025-09-21 13:58:51',
      },
      {
        port_name: 'SINGAPORE',
        latitude: 1.2666666667,
        longitude: 103.8333333333,
        distance_naut: 7007.925809216603,
        ETA: '2025-10-10 09:08:02',
        UTC_ETA: '2025-10-10 01:08:02',
      },
      {
        port_name: 'YANBU',
        latitude: 24.0833333333,
        longitude: 38.05,
        distance_naut: 2475.0816286471627,
        ETA: '2025-09-25 01:30:23',
        UTC_ETA: '2025-09-24 22:30:23',
      },
      {
        port_name: 'YOSU',
        latitude: 34.7333333333,
        longitude: 127.75,
        distance_naut: 9503.081805768232,
        ETA: '2025-10-18 17:44:47',
        UTC_ETA: '2025-10-18 08:44:47',
      },
      {
        port_name: 'FUJAIRAH',
        latitude: 25.1666666667,
        longitude: 56.35,
        distance_naut: 4705.582809969215,
        ETA: '2025-10-02 12:56:47',
        UTC_ETA: '2025-10-02 08:56:47',
      },
      {
        port_name: 'SIKKA',
        latitude: 22.5166666667,
        longitude: 69.8,
        distance_naut: 4934.209370066983,
        ETA: '2025-10-03 08:14:12',
        UTC_ETA: '2025-10-03 03:14:12',
      },
      {
        port_name: 'MALTA OPL',
        latitude: 35.9166666667,
        longitude: 14.8330555567,
        distance_naut: 1010.779750290235,
        ETA: '2025-09-20 02:21:44',
        UTC_ETA: '2025-09-20 01:21:44',
      },
    ],
    openPort: 'GIBRALTAR',
    openDate: '2025-09-16T18:30:00',
    worldArea: {
      level1: 'Europe',
      level2: 'MED',
      level3: 'West Med',
    },
    actualImpairedEarnings: null,
    actualImpairedEarningsComment: null,
    oprType: 'TCTO',
    ballastDistances: null,
    actualTce: 26458,
    estimatedTce: 30566,
    actualTceDelta: 0,
    actualEstimatedDaysDelta: 409.96,
  },
  {
    productCodes: 'ULSD',
    blCodes: '',
    cargoGrades: 'ULSD 10 PPM',
    ballastPort: 'LAS PALMAS',
    chartererShortName: 'REPSOLTRADINGSA_01092',
    commenceDate: '2024-02-12T04:00:00',
    CompleteDate: '2024-03-01T16:30:00',
    cpDate: '2024-02-13T00:00:00',
    dischargePort: 'JORF LASFAR',
    fixtureDate: null,
    itineraries: [
      {
        seq: 100,
        portName: 'LAS PALMAS',
        portFunction: 'COMMENCING',
        arrivalLocal: null,
        arrivalGmt: null,
        departureLocal: '2024-02-12T04:00:00',
        departureGmt: '2024-02-12T04:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 600,
        portName: 'CARTAGENA (SPAIN)',
        portFunction: 'LOADING',
        arrivalLocal: '2024-02-15T11:42:00',
        arrivalGmt: '2024-02-15T10:42:00',
        departureLocal: '2024-02-19T06:54:00',
        departureGmt: '2024-02-19T05:54:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 800,
        portName: 'JORF LASFAR',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-02-21T00:06:00',
        arrivalGmt: '2024-02-20T23:06:00',
        departureLocal: '2024-03-01T16:30:00',
        departureGmt: '2024-03-01T15:30:00',
        arrDepStatus: 'TE',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
    ],
    loadPort: 'CARTAGENA (SPAIN)',
    status: 'Closed',
    vesselCode: 'V198',
    voyageNumber: 24602,
    chtrCoordinatorInitials: 'AMO379',
    cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
    lastUpdateGmt: '2024-11-26T06:31:00',
    operator: 'Simranjot Kaur Mann',
    openPort: 'JORF LASFAR',
    openDate: '2024-03-01T16:30:00',
    worldArea: {},
    actualImpairedEarnings: null,
    actualImpairedEarningsComment: null,
    oprType: 'TCOV',
    ballastDistances: null,
    actualTce: 32624,
    estimatedTce: 28923,
    actualTceDelta: null,
    actualEstimatedDaysDelta: 6.73,
  },
  {
    productCodes: 'Jet',
    blCodes: '',
    cargoGrades: 'JET A1',
    ballastPort: 'PORT-LA-NOUVELLE',
    chartererShortName: 'REPSOLTRADINGSA_01092',
    commenceDate: '2024-01-29T11:36:00',
    CompleteDate: '2024-02-12T04:00:00',
    cpDate: '2024-01-30T00:00:00',
    dischargePort: 'LAS PALMAS',
    fixtureDate: null,
    itineraries: [
      {
        seq: 100,
        portName: 'PORT-LA-NOUVELLE',
        portFunction: 'COMMENCING',
        arrivalLocal: null,
        arrivalGmt: null,
        departureLocal: '2024-01-29T11:36:00',
        departureGmt: '2024-01-29T10:36:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 200,
        portName: 'PORT-LA-NOUVELLE',
        portFunction: 'WAITING',
        arrivalLocal: '2024-01-29T12:00:00',
        arrivalGmt: '2024-01-29T11:00:00',
        departureLocal: '2024-01-30T15:00:00',
        departureGmt: '2024-01-30T14:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1100,
        portName: 'AT SEA',
        portFunction: 'OTHER',
        arrivalLocal: '2024-01-31T12:00:00',
        arrivalGmt: '2024-01-31T12:00:00',
        departureLocal: '2024-01-31T12:00:00',
        departureGmt: '2024-01-31T12:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 700,
        portName: 'CARTAGENA (SPAIN)',
        portFunction: 'LOADING',
        arrivalLocal: '2024-01-31T23:30:00',
        arrivalGmt: '2024-01-31T22:30:00',
        departureLocal: '2024-02-05T18:00:00',
        departureGmt: '2024-02-05T17:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['JET A1'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 900,
        portName: 'TENERIFE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-02-08T23:54:00',
        arrivalGmt: '2024-02-08T23:54:00',
        departureLocal: '2024-02-10T08:30:00',
        departureGmt: '2024-02-10T08:30:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['JET A1'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1000,
        portName: 'LAS PALMAS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-02-10T13:12:00',
        arrivalGmt: '2024-02-10T13:12:00',
        departureLocal: '2024-02-12T04:00:00',
        departureGmt: '2024-02-12T04:00:00',
        arrDepStatus: 'TE',
        blCodes: [],
        cargoGrades: ['JET A1'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
    ],
    loadPort: 'CARTAGENA (SPAIN)',
    status: 'Closed',
    vesselCode: 'V198',
    voyageNumber: 24601,
    chtrCoordinatorInitials: 'AMO379',
    cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
    lastUpdateGmt: '2024-08-13T04:53:14',
    operator: 'Simranjot Kaur Mann',
    openPort: 'LAS PALMAS',
    openDate: '2024-02-12T04:00:00',
    worldArea: {},
    actualImpairedEarnings: null,
    actualImpairedEarningsComment: null,
    oprType: 'TCOV',
    ballastDistances: null,
    actualTce: 43622,
    estimatedTce: 38879,
    actualTceDelta: null,
    actualEstimatedDaysDelta: -0.3,
  },
  {
    productCodes: 'UMS, ULSD',
    blCodes: '2-6 WS, SLOP WING, 1WS',
    cargoGrades: 'GASOLINE, ULSD 10 PPM, GASOLINE 98R SPULP',
    ballastPort: 'ANTWERP',
    chartererShortName: 'CSSACHARTERINGANDSHIPPING_17545',
    commenceDate: '2024-01-11T08:00:00',
    CompleteDate: '2024-01-29T11:36:00',
    cpDate: '2024-01-08T00:00:00',
    dischargePort: 'PORT-LA-NOUVELLE',
    fixtureDate: null,
    itineraries: [
      {
        seq: 100,
        portName: 'ANTWERP',
        portFunction: 'COMMENCING',
        arrivalLocal: null,
        arrivalGmt: null,
        departureLocal: '2024-01-11T08:00:00',
        departureGmt: '2024-01-11T07:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 200,
        portName: 'AMSTERDAM',
        portFunction: 'LOADING',
        arrivalLocal: '2024-01-11T10:00:00',
        arrivalGmt: '2024-01-11T09:00:00',
        departureLocal: '2024-01-17T07:48:00',
        departureGmt: '2024-01-17T06:48:00',
        arrDepStatus: 'SA',
        blCodes: ['SLOP WING', '1WS', '2-6 WS'],
        cargoGrades: ['ULSD 10 PPM', 'GASOLINE 98R SPULP', 'GASOLINE'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 500,
        portName: 'FOS',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-01-24T10:42:00',
        arrivalGmt: '2024-01-24T09:42:00',
        departureLocal: '2024-01-27T17:48:00',
        departureGmt: '2024-01-27T16:48:00',
        arrDepStatus: 'SA',
        blCodes: ['SLOP WING'],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1000,
        portName: 'PORT-LA-NOUVELLE',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-01-28T00:06:00',
        arrivalGmt: '2024-01-27T23:06:00',
        departureLocal: '2024-01-29T11:36:00',
        departureGmt: '2024-01-29T10:36:00',
        arrDepStatus: 'TE',
        blCodes: [],
        cargoGrades: ['ULSD 10 PPM'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
    ],
    loadPort: 'AMSTERDAM',
    status: 'Closed',
    vesselCode: 'V198',
    voyageNumber: 24600,
    chtrCoordinatorInitials: 'SHE101',
    cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
    lastUpdateGmt: '2024-07-11T10:09:43',
    operator: 'Simranjot Kaur Mann',
    openPort: 'PORT-LA-NOUVELLE',
    openDate: '2024-01-29T11:36:00',
    worldArea: {},
    actualImpairedEarnings: null,
    actualImpairedEarningsComment: null,
    oprType: 'TCOV',
    ballastDistances: null,
    actualTce: 30059,
    estimatedTce: 28805,
    actualTceDelta: null,
    actualEstimatedDaysDelta: 5.11,
  },
  {
    productCodes: 'MCCS, Ref, TX-Cut',
    blCodes: '',
    cargoGrades: 'MCCS, REFORMATE, TX-CUT',
    ballastPort: 'LAS PALMAS',
    chartererShortName: 'CSSACHARTERINGANDSHIPPING_17545',
    commenceDate: '2023-12-18T07:00:00',
    CompleteDate: '2024-01-11T08:00:00',
    cpDate: '2023-12-19T00:00:00',
    dischargePort: 'ANTWERP',
    fixtureDate: null,
    itineraries: [
      {
        seq: 100,
        portName: 'LAS PALMAS',
        portFunction: 'COMMENCING',
        arrivalLocal: null,
        arrivalGmt: null,
        departureLocal: '2023-12-18T07:00:00',
        departureGmt: '2023-12-18T07:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: [],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 700,
        portName: 'LAVERA',
        portFunction: 'LOADING',
        arrivalLocal: '2023-12-23T09:00:00',
        arrivalGmt: '2023-12-23T08:00:00',
        departureLocal: '2023-12-28T18:00:00',
        departureGmt: '2023-12-28T17:00:00',
        arrDepStatus: 'SA',
        blCodes: [],
        cargoGrades: ['TX-CUT', 'MCCS', 'REFORMATE'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
      {
        seq: 1000,
        portName: 'ANTWERP',
        portFunction: 'DISCHARGING',
        arrivalLocal: '2024-01-04T19:00:00',
        arrivalGmt: '2024-01-04T18:00:00',
        departureLocal: '2024-01-11T08:00:00',
        departureGmt: '2024-01-11T07:00:00',
        arrDepStatus: 'TE',
        blCodes: [],
        cargoGrades: ['REFORMATE'],
        updatedAt: '2025-05-16T07:45:09.503Z',
      },
    ],
    loadPort: 'LAVERA',
    status: 'Closed',
    vesselCode: 'V198',
    voyageNumber: 23618,
    chtrCoordinatorInitials: 'AMO379',
    cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
    lastUpdateGmt: '2024-07-11T09:17:50',
    operator: 'Simranjot Kaur Mann',
    openPort: 'ANTWERP',
    openDate: '2024-01-11T08:00:00',
    worldArea: {},
    actualImpairedEarnings: null,
    actualImpairedEarningsComment: null,
    oprType: 'TCOV',
    ballastDistances: null,
    actualTce: 38410,
    estimatedTce: 37557,
    actualTceDelta: null,
    actualEstimatedDaysDelta: 4.32,
  },
]

const vessel1 = {
  pool: 'Handy',
  imoNumber: '9431276',
  status: {
    comment: null,
    createdAt: '2024-03-05T13:15:16.960Z',
    positionListStatus: 'cleaning',
    responsibleUser: {
      email: 'mtinternaluser_vt1@maersktankers.com',
      name: 'MT Internal User 1',
    },
  },
  voyages: mockVoyages,
  cargo: [],
  aisDistances: {
    distances: [
      {
        port_name: 'GIBRALTAR',
        latitude: 35.95,
        longitude: -5.7666666667,
        distance_naut: 530.1754591665823,
        ETA: '2025-05-18 03:24:28',
        UTC_ETA: '2025-05-18 01:24:28',
      },
      {
        port_name: 'HOUSTON',
        latitude: 29.75,
        longitude: -95.3333333333,
        distance_naut: 4530.598851520324,
        ETA: '2025-05-31 04:26:30',
        UTC_ETA: '2025-05-31 09:26:30',
      },
      {
        port_name: 'AMSTERDAM',
        latitude: 52.3666666667,
        longitude: 4.8833333333,
        distance_naut: 1805.5500905616755,
        ETA: '2025-05-22 09:26:16',
        UTC_ETA: '2025-05-22 07:26:16',
      },
      {
        port_name: 'SINGAPORE',
        latitude: 1.2666666667,
        longitude: 103.8333333333,
        distance_naut: 7538.101268383186,
        ETA: '2025-06-10 18:02:31',
        UTC_ETA: '2025-06-10 10:02:31',
      },
      {
        port_name: 'YANBU',
        latitude: 24.0833333333,
        longitude: 38.05,
        distance_naut: 3005.2570878137453,
        ETA: '2025-05-26 10:24:52',
        UTC_ETA: '2025-05-26 07:24:52',
      },
      {
        port_name: 'YOSU',
        latitude: 34.7333333333,
        longitude: 127.75,
        distance_naut: 10033.257264934815,
        ETA: '2025-06-19 02:39:16',
        UTC_ETA: '2025-06-18 17:39:16',
      },
      {
        port_name: 'FUJAIRAH',
        latitude: 25.1666666667,
        longitude: 56.35,
        distance_naut: 5235.7582691357975,
        ETA: '2025-06-02 21:51:16',
        UTC_ETA: '2025-06-02 17:51:16',
      },
      {
        port_name: 'SIKKA',
        latitude: 22.5166666667,
        longitude: 69.8,
        distance_naut: 5464.384829233565,
        ETA: '2025-06-03 17:08:40',
        UTC_ETA: '2025-06-03 12:08:40',
      },
      {
        port_name: 'MALTA OPL',
        latitude: 35.9166666667,
        longitude: 14.8330555567,
        distance_naut: 1540.9552094568176,
        ETA: '2025-05-21 11:16:13',
        UTC_ETA: '2025-05-21 10:16:13',
      },
    ],
    aisPositionReceived: '2025-05-16T06:59:37.960Z',
    latitude: 29.940295,
    longitude: -13.52634,
    createdAt: '2025-05-16T07:15:21.525Z',
    sdpCreatedAt: '2025-05-16T07:00:43.780Z',
  },
  beam: '27.40',
  bunkerConsumption: {
    ladenTonsPerDay: 28.61,
    ladenTonsPerDayPoolAvg: 24.125714285714285,
    ladenTonsPerDayPoolRating: 'high',
  },
  bwts: 'Yes',
  cbm: 43612,
  ciiRating: 'C',
  comments: [
    {
      tab: 'positionlist',
      field: 'comment',
      comment: '',
      createdBy: 'auth0|6272552666693e00685bb77e',
      responsibleUser: {
        email: 'sara.kristensen@maersktankers.com',
        name: 'Sara Kristensen',
      },
      createdAt: '2024-03-05T13:15:26.431Z',
      updatedAt: '2024-03-05T13:15:33.064Z',
      hash: 'cc3bd775e0977dce6bdb5cc77a0e474f3672ffe6',
      updatedBy: 'auth0|6272552666693e00685bb77e',
      updatedResponsibleUser: {
        email: 'sara.kristensen@maersktankers.com',
        name: 'Sara Kristensen',
      },
    },
  ],
  completeDate: '2025-09-16T18:30:00',
  deliveryDate: '2010-08-17',
  dpp: 'Yes',
  dwt: '39756',
  flag: 'Singapore',
  iceClass: 'No',
  igs: 'Yes',
  igsSupply: 'IG Generator',
  imoClass: '2',
  biofuelCapable: 'No',
  lastSire: {
    approval: 'Vivo',
    inspectionDate: '2025-03-11T00:00:00.000Z',
    port: 'Las Palmas',
  },
  lastThreeCargoesInternal: {
    comment: null,
    createdAt: null,
    lastThreeCargoes: null,
    responsibleUser: null,
  },
  lastUpdateGmt: '2025-05-15T06:54:01',
  loa: '183.18',
  mouldedDepth: '16.80',
  nextDryDock: '2025-08-17',
  nextDryDockInternal: {
    comment: null,
    createdAt: null,
    nextDryDock: null,
    responsibleUser: null,
  },
  openDate: '2025-09-16T18:30:00',
  openPort: 'GIBRALTAR',
  operator: 'Isha Shah',
  pbl: '103.50',
  redeliveryDate: '2032-06-02T18:30:00.000Z',
  rejections: [],
  scrubber: 'No',
  sternLine: 'No',
  summerDraft: '11.787',
  tankCoating: null,
  usCoc: {
    issued: null,
    lastAnnual: '1900-01-01',
  },
  vessel: 'Maersk Kate',
  vesselCode: 'V198',
  vesselId: '6050c4a15673da29c1aba9ab',
  worldArea: {
    level1: 'Europe',
    level2: 'MED',
    level3: 'West Med',
  },
  yearBuilt: '2010',
}

const vessel2 = {
  pool: 'MR',
  imoNumber: '9732931',
  status: {
    comment: null,
    createdAt: '2025-05-01T10:50:07.725Z',
    positionListStatus: 'onSubs',
    responsibleUser: {
      name: 'accountmanager@test.dk',
      email: 'accountmanager@test.dk',
    },
  },
  voyages: [
    {
      productCodes: 'GTL',
      blCodes: '',
      cargoGrades: 'GTL',
      ballastPort: 'DURBAN',
      chartererShortName: 'SHELLINTERNATIONALTRADING_23879',
      commenceDate: '2025-05-02T06:00:00',
      CompleteDate: '2025-07-03T16:29:31',
      cpDate: '2025-05-06T00:00:00',
      dischargePort: 'HOUSTON',
      fixtureDate: null,
      itineraries: [
        {
          seq: 100,
          portName: 'DURBAN',
          portFunction: 'COMMENCING',
          arrivalLocal: null,
          arrivalGmt: null,
          departureLocal: '2025-05-02T06:00:00',
          departureGmt: '2025-05-02T04:00:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1200,
          portName: 'AT SEA',
          portFunction: 'OTHER',
          arrivalLocal: '2025-05-13T21:30:00',
          arrivalGmt: '2025-05-13T21:30:00',
          departureLocal: '2025-05-13T23:30:00',
          departureGmt: '2025-05-13T23:30:00',
          arrDepStatus: '..',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 700,
          portName: 'RAS LAFFAN',
          portFunction: 'LOADING',
          arrivalLocal: '2025-05-16T10:00:00',
          arrivalGmt: '2025-05-16T07:00:00',
          departureLocal: '2025-05-17T16:00:00',
          departureGmt: '2025-05-17T13:00:00',
          arrDepStatus: '..',
          blCodes: [],
          cargoGrades: ['GTL'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 800,
          portName: 'FUJAIRAH',
          portFunction: 'FUELING',
          arrivalLocal: '2025-05-18T22:01:00',
          arrivalGmt: '2025-05-18T18:01:00',
          departureLocal: '2025-05-19T10:00:00',
          departureGmt: '2025-05-19T06:00:00',
          arrDepStatus: '..',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 900,
          portName: 'CAPE OF GOOD HOPE',
          portFunction: 'CANAL TRANSIT',
          arrivalLocal: '2025-06-04T02:00:00',
          arrivalGmt: '2025-06-04T00:00:00',
          departureLocal: '2025-06-04T02:00:00',
          departureGmt: '2025-06-04T00:00:00',
          arrDepStatus: '..',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1100,
          portName: 'HOUSTON',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2025-06-30T10:29:31',
          arrivalGmt: '2025-06-30T15:29:31',
          departureLocal: '2025-07-03T16:29:31',
          departureGmt: '2025-07-03T21:29:31',
          arrDepStatus: '..',
          blCodes: [],
          cargoGrades: ['GTL'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
      ],
      loadPort: 'RAS LAFFAN',
      status: 'Commenced',
      vesselCode: 'VNA8',
      voyageNumber: 25602,
      chtrCoordinatorInitials: 'JWP015',
      cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
      lastUpdateGmt: '2025-05-13T10:36:50',
      operator: 'Neelabh Srivastav',
      distances: [
        {
          port_name: 'GIBRALTAR',
          latitude: 35.95,
          longitude: -5.7666666667,
          distance_naut: 4733.986921992377,
          ETA: '2025-07-19 18:12:39',
          UTC_ETA: '2025-07-19 16:12:39',
        },
        {
          port_name: 'HOUSTON',
          latitude: 29.75,
          longitude: -95.3333333333,
          distance_naut: 0,
          ETA: '2025-07-03 16:29:31',
          UTC_ETA: '2025-07-03 21:29:31',
        },
        {
          port_name: 'AMSTERDAM',
          latitude: 52.3666666667,
          longitude: 4.8833333333,
          distance_naut: 5112.578791704498,
          ETA: '2025-07-21 00:29:53',
          UTC_ETA: '2025-07-20 22:29:53',
        },
        {
          port_name: 'SINGAPORE',
          latitude: 1.2666666667,
          longitude: 103.8333333333,
          distance_naut: 11741.912731208973,
          ETA: '2025-08-12 08:50:41',
          UTC_ETA: '2025-08-12 00:50:41',
        },
        {
          port_name: 'YANBU',
          latitude: 24.0833333333,
          longitude: 38.05,
          distance_naut: 7209.06855063954,
          ETA: '2025-07-28 01:13:02',
          UTC_ETA: '2025-07-27 22:13:02',
        },
        {
          port_name: 'YOSU',
          latitude: 34.7333333333,
          longitude: 127.75,
          distance_naut: 9970.144923683196,
          ETA: '2025-08-06 12:06:12',
          UTC_ETA: '2025-08-06 03:06:12',
        },
        {
          port_name: 'FUJAIRAH',
          latitude: 25.1666666667,
          longitude: 56.35,
          distance_naut: 9439.569731961594,
          ETA: '2025-08-04 12:39:27',
          UTC_ETA: '2025-08-04 08:39:27',
        },
        {
          port_name: 'SIKKA',
          latitude: 22.5166666667,
          longitude: 69.8,
          distance_naut: 9668.19629205936,
          ETA: '2025-08-05 07:56:51',
          UTC_ETA: '2025-08-05 02:56:51',
        },
        {
          port_name: 'MALTA OPL',
          latitude: 35.9166666667,
          longitude: 14.8330555567,
          distance_naut: 5744.766672282612,
          ETA: '2025-07-23 02:04:23',
          UTC_ETA: '2025-07-23 01:04:23',
        },
      ],
      openPort: 'HOUSTON',
      openDate: '2025-07-03T16:29:31',
      worldArea: {
        level1: 'Americas',
        level2: 'Atlantic Basin',
        level3: 'USG-Caribs',
      },
      actualImpairedEarnings: null,
      actualImpairedEarningsComment: null,
      oprType: 'TCOV',
      ballastDistances: [
        {
          seq: 100,
          portname: 'DURBAN',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 5941.897870460051,
              ETA: '2025-05-22 01:21:06',
              UTC_ETA: '2025-05-21 23:21:06',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 8326.552565264801,
              ETA: '2025-05-29 17:07:27',
              UTC_ETA: '2025-05-29 22:07:27',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 7137.968304345903,
              ETA: '2025-05-26 01:02:14',
              UTC_ETA: '2025-05-25 23:02:14',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 4925.913028116661,
              ETA: '2025-05-18 22:04:22',
              UTC_ETA: '2025-05-18 14:04:22',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 4096.376461081503,
              ETA: '2025-05-15 22:42:36',
              UTC_ETA: '2025-05-15 19:42:36',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 7268.21314813355,
              ETA: '2025-05-26 18:27:25',
              UTC_ETA: '2025-05-26 09:27:25',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 3833.5811246697544,
              ETA: '2025-05-15 02:41:11',
              UTC_ETA: '2025-05-14 22:41:11',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 3966.6251173085034,
              ETA: '2025-05-15 14:19:48',
              UTC_ETA: '2025-05-15 09:19:48',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 5569.73524854944,
              ETA: '2025-05-20 18:34:43',
              UTC_ETA: '2025-05-20 17:34:43',
            },
          ],
        },
        {
          seq: 200,
          portname: 'RAS LAFFAN',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 5042.019230181595,
              ETA: '2025-06-03 11:21:41',
              UTC_ETA: '2025-06-03 09:21:41',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 9776.006152173974,
              ETA: '2025-06-18 23:04:49',
              UTC_ETA: '2025-06-19 04:04:49',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 6510.529658638619,
              ETA: '2025-06-08 08:50:32',
              UTC_ETA: '2025-06-08 06:50:32',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 3673.3517727467024,
              ETA: '2025-05-30 03:52:05',
              UTC_ETA: '2025-05-29 19:52:05',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 2566.939106322051,
              ETA: '2025-05-26 06:21:18',
              UTC_ETA: '2025-05-26 03:21:18',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 6168.5077692983305,
              ETA: '2025-06-07 12:28:50',
              UTC_ETA: '2025-06-07 03:28:50',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 336.43642021237963,
              ETA: '2025-05-18 20:54:53',
              UTC_ETA: '2025-05-18 16:54:53',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 1016.5568660297325,
              ETA: '2025-05-21 04:19:28',
              UTC_ETA: '2025-05-20 23:19:28',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 4040.297893789987,
              ETA: '2025-05-31 02:13:25',
              UTC_ETA: '2025-05-31 01:13:25',
            },
          ],
        },
      ],
      actualTce: 21224,
      estimatedTce: 22776,
      actualTceDelta: 0,
      actualEstimatedDaysDelta: -0.8,
    },
    {
      productCodes: 'UMS',
      blCodes: '1W-6W, SLP S',
      cargoGrades: 'UNLEADED GASOLINE',
      ballastPort: 'HALDIA',
      chartererShortName: 'RELIANCEINTERNATIONALLIMITED_628',
      commenceDate: '2025-03-30T14:30:00',
      CompleteDate: '2025-05-02T06:00:00',
      cpDate: '2025-04-08T00:00:00',
      dischargePort: 'DURBAN',
      fixtureDate: null,
      itineraries: [
        {
          seq: 100,
          portName: 'HALDIA',
          portFunction: 'COMMENCING',
          arrivalLocal: null,
          arrivalGmt: null,
          departureLocal: '2025-03-30T14:30:00',
          departureGmt: '2025-03-30T09:00:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 300,
          portName: 'AT SEA',
          portFunction: 'OTHER',
          arrivalLocal: '2025-03-31T12:00:00',
          arrivalGmt: '2025-03-31T06:30:00',
          departureLocal: '2025-03-31T12:00:00',
          departureGmt: '2025-03-31T06:30:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 200,
          portName: 'SIKKA',
          portFunction: 'FUELING',
          arrivalLocal: '2025-04-09T16:30:00',
          arrivalGmt: '2025-04-09T11:00:00',
          departureLocal: '2025-04-13T14:48:00',
          departureGmt: '2025-04-13T09:18:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 800,
          portName: 'SIKKA',
          portFunction: 'LOADING',
          arrivalLocal: '2025-04-13T14:48:00',
          arrivalGmt: '2025-04-13T09:18:00',
          departureLocal: '2025-04-15T02:00:00',
          departureGmt: '2025-04-14T20:30:00',
          arrDepStatus: 'SA',
          blCodes: ['1W-6W, SLP S'],
          cargoGrades: ['UNLEADED GASOLINE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 900,
          portName: 'DURBAN',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2025-04-28T19:30:00',
          arrivalGmt: '2025-04-28T17:30:00',
          departureLocal: '2025-05-02T06:00:00',
          departureGmt: '2025-05-02T04:00:00',
          arrDepStatus: 'TE',
          blCodes: ['1W-6W, SLP S'],
          cargoGrades: ['UNLEADED GASOLINE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
      ],
      loadPort: 'SIKKA',
      status: 'Completed',
      vesselCode: 'VNA8',
      voyageNumber: 25601,
      chtrCoordinatorInitials: 'JWP015',
      cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
      lastUpdateGmt: '2025-05-09T08:43:28',
      operator: 'Rajiv Kumar',
      distances: [
        {
          port_name: 'GIBRALTAR',
          latitude: 35.95,
          longitude: -5.7666666667,
          distance_naut: 5941.897870460051,
          ETA: '2025-05-22 07:21:06',
          UTC_ETA: '2025-05-22 05:21:06',
        },
        {
          port_name: 'HOUSTON',
          latitude: 29.75,
          longitude: -95.3333333333,
          distance_naut: 8326.552565264801,
          ETA: '2025-05-29 23:07:27',
          UTC_ETA: '2025-05-30 04:07:27',
        },
        {
          port_name: 'AMSTERDAM',
          latitude: 52.3666666667,
          longitude: 4.8833333333,
          distance_naut: 7137.968304345903,
          ETA: '2025-05-26 07:02:14',
          UTC_ETA: '2025-05-26 05:02:14',
        },
        {
          port_name: 'SINGAPORE',
          latitude: 1.2666666667,
          longitude: 103.8333333333,
          distance_naut: 4925.913028116661,
          ETA: '2025-05-19 04:04:22',
          UTC_ETA: '2025-05-18 20:04:22',
        },
        {
          port_name: 'YANBU',
          latitude: 24.0833333333,
          longitude: 38.05,
          distance_naut: 4096.376461081503,
          ETA: '2025-05-16 04:42:36',
          UTC_ETA: '2025-05-16 01:42:36',
        },
        {
          port_name: 'YOSU',
          latitude: 34.7333333333,
          longitude: 127.75,
          distance_naut: 7268.21314813355,
          ETA: '2025-05-27 00:27:25',
          UTC_ETA: '2025-05-26 15:27:25',
        },
        {
          port_name: 'FUJAIRAH',
          latitude: 25.1666666667,
          longitude: 56.35,
          distance_naut: 3833.5811246697544,
          ETA: '2025-05-15 08:41:11',
          UTC_ETA: '2025-05-15 04:41:11',
        },
        {
          port_name: 'SIKKA',
          latitude: 22.5166666667,
          longitude: 69.8,
          distance_naut: 3966.6251173085034,
          ETA: '2025-05-15 20:19:48',
          UTC_ETA: '2025-05-15 15:19:48',
        },
        {
          port_name: 'MALTA OPL',
          latitude: 35.9166666667,
          longitude: 14.8330555567,
          distance_naut: 5569.73524854944,
          ETA: '2025-05-21 00:34:43',
          UTC_ETA: '2025-05-20 23:34:43',
        },
      ],
      openPort: 'DURBAN',
      openDate: '2025-05-02T06:00:00',
      worldArea: {
        level1: 'East of Suez',
        level2: 'AG',
        level3: 'East- & South Africa',
      },
      actualImpairedEarnings: null,
      actualImpairedEarningsComment: null,
      oprType: 'TCOV',
      ballastDistances: [
        {
          seq: 100,
          portname: 'HALDIA',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 6544.210883961732,
              ETA: '2025-04-21 07:02:12',
              UTC_ETA: '2025-04-21 05:02:12',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 11278.197805954109,
              ETA: '2025-05-06 18:45:20',
              UTC_ETA: '2025-05-06 23:45:20',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 8012.7213124187565,
              ETA: '2025-04-26 04:31:03',
              UTC_ETA: '2025-04-26 02:31:03',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 1528.2681002022637,
              ETA: '2025-04-04 19:45:41',
              UTC_ETA: '2025-04-04 11:45:41',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 4069.130760102187,
              ETA: '2025-04-13 02:01:49',
              UTC_ETA: '2025-04-12 23:01:49',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 4023.4240967538926,
              ETA: '2025-04-13 04:22:26',
              UTC_ETA: '2025-04-12 19:22:26',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 2873.200427279452,
              ETA: '2025-04-09 03:21:21',
              UTC_ETA: '2025-04-08 23:21:21',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 2356.8268198289265,
              ETA: '2025-04-07 11:02:46',
              UTC_ETA: '2025-04-07 06:02:46',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 5542.489547570124,
              ETA: '2025-04-17 21:53:56',
              UTC_ETA: '2025-04-17 20:53:56',
            },
          ],
        },
        {
          seq: 300,
          portname: 'AT SEA',
          distances: [
            {
              port_name: 'AMSTERDAM',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'FUJAIRAH',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'GIBRALTAR',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'HOUSTON',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'MALTA OPL',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'SIKKA',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'SINGAPORE',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'YANBU',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'YOSU',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
          ],
        },
        {
          seq: 200,
          portname: 'SIKKA',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 4934.209370066983,
              ETA: '2025-04-29 00:01:12',
              UTC_ETA: '2025-04-28 22:01:12',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 9668.19629205936,
              ETA: '2025-05-14 11:44:20',
              UTC_ETA: '2025-05-14 16:44:20',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 6402.719798524007,
              ETA: '2025-05-03 21:30:03',
              UTC_ETA: '2025-05-03 19:30:03',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 2820.5417450837977,
              ETA: '2025-04-22 04:55:36',
              UTC_ETA: '2025-04-21 20:55:36',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 2459.129246207439,
              ETA: '2025-04-20 19:00:49',
              UTC_ETA: '2025-04-20 16:00:49',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 5315.697741635426,
              ETA: '2025-04-30 13:32:20',
              UTC_ETA: '2025-04-30 04:32:20',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 680.1204458173529,
              ETA: '2025-04-14 21:41:34',
              UTC_ETA: '2025-04-14 17:41:34',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 0,
              ETA: '2025-04-12 16:17:00',
              UTC_ETA: '2025-04-12 11:17:00',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 3932.488033675375,
              ETA: '2025-04-25 14:52:56',
              UTC_ETA: '2025-04-25 13:52:56',
            },
          ],
        },
      ],
      actualTce: 20594,
      estimatedTce: 22584,
      actualTceDelta: 750,
      actualEstimatedDaysDelta: 2.32,
    },
    {
      productCodes: 'SBO, SFSO',
      blCodes: '2-4W, 6W, 2W, 3W, 4W, 6W, 1W',
      cargoGrades: 'CRUDE DEGUMMED SOYABEAN OIL, CRUDSE SUNFLOWER OIL',
      ballastPort: 'BUENOS AIRES',
      chartererShortName: 'OLAMGLOBALAGRIPTELTD_62617',
      commenceDate: '2025-01-29T08:00:00',
      CompleteDate: '2025-03-30T14:30:00',
      cpDate: '2025-01-31T00:00:00',
      dischargePort: 'HALDIA',
      fixtureDate: null,
      itineraries: [
        {
          seq: 100,
          portName: 'BUENOS AIRES',
          portFunction: 'COMMENCING',
          arrivalLocal: null,
          arrivalGmt: null,
          departureLocal: '2025-01-29T08:00:00',
          departureGmt: '2025-01-29T11:00:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 200,
          portName: 'AT SEA',
          portFunction: 'OTHER',
          arrivalLocal: '2025-01-30T11:54:00',
          arrivalGmt: '2025-01-30T11:54:00',
          departureLocal: '2025-02-06T11:00:00',
          departureGmt: '2025-02-06T11:00:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1000,
          portName: 'RECALADA PILOT STATION',
          portFunction: 'WAITING',
          arrivalLocal: '2025-02-06T11:00:00',
          arrivalGmt: '2025-02-06T14:00:00',
          departureLocal: '2025-02-07T13:54:00',
          departureGmt: '2025-02-07T16:54:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1100,
          portName: 'SAN LORENZO-SAN MARTIN',
          portFunction: 'LOADING',
          arrivalLocal: '2025-02-09T01:12:00',
          arrivalGmt: '2025-02-09T04:12:00',
          departureLocal: '2025-02-14T16:18:00',
          departureGmt: '2025-02-14T19:18:00',
          arrDepStatus: 'SA',
          blCodes: ['2-4W, 6W', '1W', '2W, 3W, 4W, 6W'],
          cargoGrades: ['CRUDE DEGUMMED SOYABEAN OIL', 'CRUDSE SUNFLOWER OIL'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1200,
          portName: 'ZONA COMUN',
          portFunction: 'FUELING',
          arrivalLocal: '2025-02-15T13:42:00',
          arrivalGmt: '2025-02-15T16:42:00',
          departureLocal: '2025-02-17T09:30:00',
          departureGmt: '2025-02-17T12:30:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1500,
          portName: 'KRISHNAPATNAM',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2025-03-20T06:30:00',
          arrivalGmt: '2025-03-20T01:00:00',
          departureLocal: '2025-03-22T23:48:00',
          departureGmt: '2025-03-22T18:18:00',
          arrDepStatus: 'SA',
          blCodes: ['2-4W, 6W'],
          cargoGrades: ['CRUDE DEGUMMED SOYABEAN OIL'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1600,
          portName: 'HALDIA',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2025-03-25T06:30:00',
          arrivalGmt: '2025-03-25T01:00:00',
          departureLocal: '2025-03-30T14:30:00',
          departureGmt: '2025-03-30T09:00:00',
          arrDepStatus: 'TE',
          blCodes: ['2W, 3W, 4W, 6W', '1W'],
          cargoGrades: ['CRUDE DEGUMMED SOYABEAN OIL', 'CRUDSE SUNFLOWER OIL'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
      ],
      loadPort: 'SAN LORENZO-SAN MARTIN',
      status: 'Completed',
      vesselCode: 'VNA8',
      voyageNumber: 25600,
      chtrCoordinatorInitials: 'WME024',
      cargoGroup: 'VEGETABLE OILS',
      lastUpdateGmt: '2025-05-08T15:26:09',
      operator: 'Almitra Manjrekar',
      distances: [
        {
          port_name: 'GIBRALTAR',
          latitude: 35.95,
          longitude: -5.7666666667,
          distance_naut: 6544.210883961732,
          ETA: '2025-04-20 09:32:12',
          UTC_ETA: '2025-04-20 08:32:12',
        },
        {
          port_name: 'HOUSTON',
          latitude: 29.75,
          longitude: -95.3333333333,
          distance_naut: 11278.197805954109,
          ETA: '2025-05-05 21:15:20',
          UTC_ETA: '2025-05-06 03:15:20',
        },
        {
          port_name: 'AMSTERDAM',
          latitude: 52.3666666667,
          longitude: 4.8833333333,
          distance_naut: 8012.7213124187565,
          ETA: '2025-04-25 07:01:03',
          UTC_ETA: '2025-04-25 06:01:03',
        },
        {
          port_name: 'SINGAPORE',
          latitude: 1.2666666667,
          longitude: 103.8333333333,
          distance_naut: 1528.2681002022637,
          ETA: '2025-04-03 23:15:41',
          UTC_ETA: '2025-04-03 15:15:41',
        },
        {
          port_name: 'YANBU',
          latitude: 24.0833333333,
          longitude: 38.05,
          distance_naut: 4069.130760102187,
          ETA: '2025-04-12 05:31:49',
          UTC_ETA: '2025-04-12 02:31:49',
        },
        {
          port_name: 'YOSU',
          latitude: 34.7333333333,
          longitude: 127.75,
          distance_naut: 4023.4240967538926,
          ETA: '2025-04-12 07:52:26',
          UTC_ETA: '2025-04-11 22:52:26',
        },
        {
          port_name: 'FUJAIRAH',
          latitude: 25.1666666667,
          longitude: 56.35,
          distance_naut: 2873.200427279452,
          ETA: '2025-04-08 06:51:21',
          UTC_ETA: '2025-04-08 02:51:21',
        },
        {
          port_name: 'SIKKA',
          latitude: 22.5166666667,
          longitude: 69.8,
          distance_naut: 2356.8268198289265,
          ETA: '2025-04-06 14:32:46',
          UTC_ETA: '2025-04-06 09:32:46',
        },
        {
          port_name: 'MALTA OPL',
          latitude: 35.9166666667,
          longitude: 14.8330555567,
          distance_naut: 5542.489547570124,
          ETA: '2025-04-17 01:23:56',
          UTC_ETA: '2025-04-17 00:23:56',
        },
      ],
      openPort: 'HALDIA',
      openDate: '2025-03-30T14:30:00',
      worldArea: {
        level1: 'East of Suez',
        level2: 'ASIA',
        level3: 'SE Asia',
      },
      actualImpairedEarnings: null,
      actualImpairedEarningsComment: null,
      oprType: 'TCOV',
      ballastDistances: [
        {
          seq: 100,
          portname: 'BUENOS AIRES',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 5339.9120578756765,
              ETA: '2025-02-16 07:11:34',
              UTC_ETA: '2025-02-16 06:11:34',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 6522.180294275725,
              ETA: '2025-02-19 22:46:27',
              UTC_ETA: '2025-02-20 04:46:27',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 6476.850997184588,
              ETA: '2025-02-20 02:08:53',
              UTC_ETA: '2025-02-20 01:08:53',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 9242.955662778999,
              ETA: '2025-03-01 14:26:11',
              UTC_ETA: '2025-03-01 06:26:11',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 7814.993686522839,
              ETA: '2025-02-24 15:11:58',
              UTC_ETA: '2025-02-24 12:11:58',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 11434.06468469245,
              ETA: '2025-03-08 22:43:30',
              UTC_ETA: '2025-03-08 13:43:30',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 8409.087285052872,
              ETA: '2025-02-26 15:43:37',
              UTC_ETA: '2025-02-26 11:43:37',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 8542.131277691618,
              ETA: '2025-02-27 03:22:13',
              UTC_ETA: '2025-02-26 22:22:13',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 6350.691808165911,
              ETA: '2025-02-19 16:03:19',
              UTC_ETA: '2025-02-19 15:03:19',
            },
          ],
        },
        {
          seq: 200,
          portname: 'AT SEA',
          distances: [
            {
              port_name: 'AMSTERDAM',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'FUJAIRAH',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'GIBRALTAR',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'HOUSTON',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'MALTA OPL',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'SIKKA',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'SINGAPORE',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'YANBU',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
            {
              port_name: 'YOSU',
              latitude: null,
              longitude: null,
              distance_naut: null,
              ETA: null,
              UTC_ETA: null,
            },
          ],
        },
      ],
      actualTce: 20214,
      estimatedTce: 19263,
      actualTceDelta: 167,
      actualEstimatedDaysDelta: 4.57,
    },
    {
      productCodes: 'UMS, Ref',
      blCodes: 'ALL TANKS 2, ALL',
      cargoGrades: 'UNLEADED GASOLINE, REFORMATE',
      ballastPort: 'OFFSHORE LOME',
      chartererShortName: 'BPOILINTERNATIONALLIMITED_46966',
      commenceDate: '2024-12-02T15:30:00',
      CompleteDate: '2025-01-29T08:00:00',
      cpDate: '2024-12-14T00:00:00',
      dischargePort: 'BUENOS AIRES',
      fixtureDate: null,
      itineraries: [
        {
          seq: 100,
          portName: 'OFFSHORE LOME',
          portFunction: 'COMMENCING',
          arrivalLocal: null,
          arrivalGmt: null,
          departureLocal: '2024-12-02T15:30:00',
          departureGmt: '2024-12-02T15:30:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 700,
          portName: 'BARCELONA',
          portFunction: 'LOADING',
          arrivalLocal: '2024-12-15T21:30:00',
          arrivalGmt: '2024-12-15T20:30:00',
          departureLocal: '2024-12-18T09:30:00',
          departureGmt: '2024-12-18T08:30:00',
          arrDepStatus: 'SA',
          blCodes: ['ALL'],
          cargoGrades: ['REFORMATE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1200,
          portName: 'CASTELLON DE LA PLANA',
          portFunction: 'LOADING',
          arrivalLocal: '2024-12-18T19:30:00',
          arrivalGmt: '2024-12-18T18:30:00',
          departureLocal: '2024-12-22T21:30:00',
          departureGmt: '2024-12-22T20:30:00',
          arrDepStatus: 'SA',
          blCodes: ['ALL TANKS 2'],
          cargoGrades: ['UNLEADED GASOLINE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 1400,
          portName: 'ALPHA LIGHTERING ZONE',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2025-01-11T14:30:00',
          arrivalGmt: '2025-01-11T17:30:00',
          departureLocal: '2025-01-17T07:18:00',
          departureGmt: '2025-01-17T10:18:00',
          arrDepStatus: 'SA',
          blCodes: ['ALL TANKS 2'],
          cargoGrades: ['UNLEADED GASOLINE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 900,
          portName: 'BUENOS AIRES',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2025-01-17T08:30:00',
          arrivalGmt: '2025-01-17T11:30:00',
          departureLocal: '2025-01-29T08:00:00',
          departureGmt: '2025-01-29T11:00:00',
          arrDepStatus: 'TE',
          blCodes: ['ALL TANKS 2', 'ALL'],
          cargoGrades: ['UNLEADED GASOLINE', 'REFORMATE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
      ],
      loadPort: 'BARCELONA',
      status: 'Completed',
      vesselCode: 'VNA8',
      voyageNumber: 24605,
      chtrCoordinatorInitials: 'MPR133',
      cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
      lastUpdateGmt: '2025-05-12T15:49:55',
      operator: 'Aarti Kanwar',
      distances: [
        {
          port_name: 'GIBRALTAR',
          latitude: 35.95,
          longitude: -5.7666666667,
          distance_naut: 5339.9120578756765,
          ETA: '2025-02-02 02:11:34',
          UTC_ETA: '2025-02-02 01:11:34',
        },
        {
          port_name: 'HOUSTON',
          latitude: 29.75,
          longitude: -95.3333333333,
          distance_naut: 6522.180294275725,
          ETA: '2025-02-05 17:46:27',
          UTC_ETA: '2025-02-05 23:46:27',
        },
        {
          port_name: 'AMSTERDAM',
          latitude: 52.3666666667,
          longitude: 4.8833333333,
          distance_naut: 6476.850997184588,
          ETA: '2025-02-05 21:08:53',
          UTC_ETA: '2025-02-05 20:08:53',
        },
        {
          port_name: 'SINGAPORE',
          latitude: 1.2666666667,
          longitude: 103.8333333333,
          distance_naut: 9242.955662778999,
          ETA: '2025-02-15 09:26:11',
          UTC_ETA: '2025-02-15 01:26:11',
        },
        {
          port_name: 'YANBU',
          latitude: 24.0833333333,
          longitude: 38.05,
          distance_naut: 7814.993686522839,
          ETA: '2025-02-10 10:11:58',
          UTC_ETA: '2025-02-10 07:11:58',
        },
        {
          port_name: 'YOSU',
          latitude: 34.7333333333,
          longitude: 127.75,
          distance_naut: 11434.06468469245,
          ETA: '2025-02-22 17:43:30',
          UTC_ETA: '2025-02-22 08:43:30',
        },
        {
          port_name: 'FUJAIRAH',
          latitude: 25.1666666667,
          longitude: 56.35,
          distance_naut: 8409.087285052872,
          ETA: '2025-02-12 10:43:37',
          UTC_ETA: '2025-02-12 06:43:37',
        },
        {
          port_name: 'SIKKA',
          latitude: 22.5166666667,
          longitude: 69.8,
          distance_naut: 8542.131277691618,
          ETA: '2025-02-12 22:22:13',
          UTC_ETA: '2025-02-12 17:22:13',
        },
        {
          port_name: 'MALTA OPL',
          latitude: 35.9166666667,
          longitude: 14.8330555567,
          distance_naut: 6350.691808165911,
          ETA: '2025-02-05 11:03:19',
          UTC_ETA: '2025-02-05 10:03:19',
        },
      ],
      openPort: 'BUENOS AIRES',
      openDate: '2025-01-29T08:00:00',
      worldArea: {
        level1: 'Americas',
        level2: 'Atlantic Basin',
        level3: 'EC SAM',
      },
      actualImpairedEarnings: null,
      actualImpairedEarningsComment: null,
      oprType: 'TCOV',
      ballastDistances: [
        {
          seq: 100,
          portname: 'OFFSHORE LOME',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 3102.1653129952724,
              ETA: '2024-12-13 00:40:23',
              UTC_ETA: '2024-12-12 23:40:23',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 6062.73222309287,
              ETA: '2024-12-22 14:31:06',
              UTC_ETA: '2024-12-22 20:31:06',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 4298.235746881125,
              ETA: '2024-12-17 00:21:31',
              UTC_ETA: '2024-12-16 23:21:31',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 8240.848256696418,
              ETA: '2024-12-30 10:46:04',
              UTC_ETA: '2024-12-30 02:46:04',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 5577.246941642436,
              ETA: '2024-12-21 08:40:47',
              UTC_ETA: '2024-12-21 05:40:47',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 10583.145045980116,
              ETA: '2025-01-07 07:09:05',
              UTC_ETA: '2025-01-06 22:09:05',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 7273.026270199304,
              ETA: '2024-12-27 01:20:31',
              UTC_ETA: '2024-12-26 21:20:31',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 7406.070262838053,
              ETA: '2024-12-27 12:59:08',
              UTC_ETA: '2024-12-27 07:59:08',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 4112.945063285507,
              ETA: '2024-12-16 09:32:08',
              UTC_ETA: '2024-12-16 08:32:08',
            },
          ],
        },
        {
          seq: 200,
          portname: 'BARCELONA',
          distances: [
            {
              port_name: 'GIBRALTAR',
              latitude: 35.95,
              longitude: -5.7666666667,
              distance_naut: 554.7648252330187,
              ETA: '2024-12-19 06:22:52',
              UTC_ETA: '2024-12-19 05:22:52',
            },
            {
              port_name: 'HOUSTON',
              latitude: 29.75,
              longitude: -95.3333333333,
              distance_naut: 5288.751747225396,
              ETA: '2025-01-03 18:06:00',
              UTC_ETA: '2025-01-04 00:06:00',
            },
            {
              port_name: 'AMSTERDAM',
              latitude: 52.3666666667,
              longitude: 4.8833333333,
              distance_naut: 2023.2752536900473,
              ETA: '2024-12-24 03:51:43',
              UTC_ETA: '2024-12-24 02:51:43',
            },
            {
              port_name: 'SINGAPORE',
              latitude: 1.2666666667,
              longitude: 103.8333333333,
              distance_naut: 6664.103847756435,
              ETA: '2025-01-08 22:07:41',
              UTC_ETA: '2025-01-08 14:07:41',
            },
            {
              port_name: 'YANBU',
              latitude: 24.0833333333,
              longitude: 38.05,
              distance_naut: 2131.2596671869965,
              ETA: '2024-12-24 14:30:02',
              UTC_ETA: '2024-12-24 11:30:02',
            },
            {
              port_name: 'YOSU',
              latitude: 34.7333333333,
              longitude: 127.75,
              distance_naut: 9159.259844308066,
              ETA: '2025-01-17 06:44:26',
              UTC_ETA: '2025-01-16 21:44:26',
            },
            {
              port_name: 'FUJAIRAH',
              latitude: 25.1666666667,
              longitude: 56.35,
              distance_naut: 4361.760848509049,
              ETA: '2025-01-01 01:56:27',
              UTC_ETA: '2024-12-31 21:56:27',
            },
            {
              port_name: 'SIKKA',
              latitude: 22.5166666667,
              longitude: 69.8,
              distance_naut: 4590.387408606817,
              ETA: '2025-01-01 21:13:51',
              UTC_ETA: '2025-01-01 16:13:51',
            },
            {
              port_name: 'MALTA OPL',
              latitude: 35.9166666667,
              longitude: 14.8330555567,
              distance_naut: 668.9286036608024,
              ETA: '2024-12-19 15:30:51',
              UTC_ETA: '2024-12-19 14:30:51',
            },
          ],
        },
      ],
      actualTce: 33668,
      estimatedTce: 31756,
      actualTceDelta: -446,
      actualEstimatedDaysDelta: 9.41,
    },
    {
      productCodes: 'UMS',
      blCodes: '1W-SLOPS',
      cargoGrades: 'UNLEADED GASOLINE',
      ballastPort: 'WEST THURROCK',
      chartererShortName: 'MOCOHSA_43598',
      commenceDate: '2024-11-03T14:00:00',
      CompleteDate: '2024-12-02T15:30:00',
      cpDate: '2024-10-30T00:00:00',
      dischargePort: 'OFFSHORE LOME',
      fixtureDate: null,
      itineraries: [
        {
          seq: 100,
          portName: 'WEST THURROCK',
          portFunction: 'COMMENCING',
          arrivalLocal: null,
          arrivalGmt: null,
          departureLocal: '2024-11-03T14:00:00',
          departureGmt: '2024-11-03T14:00:00',
          arrDepStatus: 'SA',
          blCodes: [],
          cargoGrades: [],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 200,
          portName: 'MONGSTAD',
          portFunction: 'LOADING',
          arrivalLocal: '2024-11-06T18:18:00',
          arrivalGmt: '2024-11-06T17:18:00',
          departureLocal: '2024-11-09T01:30:00',
          departureGmt: '2024-11-09T00:30:00',
          arrDepStatus: 'SA',
          blCodes: ['1W-SLOPS'],
          cargoGrades: ['UNLEADED GASOLINE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
        {
          seq: 300,
          portName: 'OFFSHORE LOME',
          portFunction: 'DISCHARGING',
          arrivalLocal: '2024-11-25T21:00:00',
          arrivalGmt: '2024-11-25T21:00:00',
          departureLocal: '2024-12-02T15:30:00',
          departureGmt: '2024-12-02T15:30:00',
          arrDepStatus: 'TE',
          blCodes: ['1W-SLOPS'],
          cargoGrades: ['UNLEADED GASOLINE'],
          updatedAt: '2025-05-16T11:45:08.410Z',
        },
      ],
      loadPort: 'MONGSTAD',
      status: 'Completed',
      vesselCode: 'VNA8',
      voyageNumber: 24604,
      chtrCoordinatorInitials: 'PCO100',
      cargoGroup: 'CLEAN PETROLEUM PRODUCTS',
      lastUpdateGmt: '2025-03-12T13:00:48',
      operator: 'Pushkar Sidhaye',
      openPort: 'OFFSHORE LOME',
      openDate: '2024-12-02T15:30:00',
      worldArea: {
        level1: 'Europe',
        level2: 'WAF',
        level3: 'WAF',
      },
      actualImpairedEarnings: null,
      actualImpairedEarningsComment: null,
      oprType: 'TCOV',
      ballastDistances: null,
      actualTce: 21176,
      estimatedTce: 21957,
      actualTceDelta: 605,
      actualEstimatedDaysDelta: -5.41,
    },
  ],
  cargo: [
    {
      cargoId: '6810a5c05b0076827ea905d4',
    },
  ],
  aisDistances: {
    distances: [
      {
        port_name: 'GIBRALTAR',
        latitude: 35.95,
        longitude: -5.7666666667,
        distance_naut: 5042.019230181595,
        ETA: '2025-06-02 08:21:19',
        UTC_ETA: '2025-06-02 06:21:19',
      },
      {
        port_name: 'HOUSTON',
        latitude: 29.75,
        longitude: -95.3333333333,
        distance_naut: 9776.006152173974,
        ETA: '2025-06-17 20:04:27',
        UTC_ETA: '2025-06-18 01:04:27',
      },
      {
        port_name: 'AMSTERDAM',
        latitude: 52.3666666667,
        longitude: 4.8833333333,
        distance_naut: 6510.529658638619,
        ETA: '2025-06-07 05:50:10',
        UTC_ETA: '2025-06-07 03:50:10',
      },
      {
        port_name: 'SINGAPORE',
        latitude: 1.2666666667,
        longitude: 103.8333333333,
        distance_naut: 3673.3517727467024,
        ETA: '2025-05-29 00:51:43',
        UTC_ETA: '2025-05-28 16:51:43',
      },
      {
        port_name: 'YANBU',
        latitude: 24.0833333333,
        longitude: 38.05,
        distance_naut: 2566.939106322051,
        ETA: '2025-05-25 03:20:56',
        UTC_ETA: '2025-05-25 00:20:56',
      },
      {
        port_name: 'YOSU',
        latitude: 34.7333333333,
        longitude: 127.75,
        distance_naut: 6168.5077692983305,
        ETA: '2025-06-06 09:28:28',
        UTC_ETA: '2025-06-06 00:28:28',
      },
      {
        port_name: 'FUJAIRAH',
        latitude: 25.1666666667,
        longitude: 56.35,
        distance_naut: 336.43642021237963,
        ETA: '2025-05-17 17:54:31',
        UTC_ETA: '2025-05-17 13:54:31',
      },
      {
        port_name: 'SIKKA',
        latitude: 22.5166666667,
        longitude: 69.8,
        distance_naut: 1016.5568660297325,
        ETA: '2025-05-20 01:19:06',
        UTC_ETA: '2025-05-19 20:19:06',
      },
      {
        port_name: 'MALTA OPL',
        latitude: 35.9166666667,
        longitude: 14.8330555567,
        distance_naut: 4040.297893789987,
        ETA: '2025-05-29 23:13:03',
        UTC_ETA: '2025-05-29 22:13:03',
      },
    ],
    aisPositionReceived: '2025-05-16T10:59:37.820Z',
    latitude: 25.92506,
    longitude: 51.616238,
    createdAt: '2025-05-16T11:15:23.137Z',
    sdpCreatedAt: '2025-05-16T11:00:34.887Z',
  },
  beam: '32.20',
  bunkerConsumption: {
    ladenTonsPerDay: 19.4,
    ladenTonsPerDayPoolAvg: 23.46875,
    ladenTonsPerDayPoolRating: 'low',
  },
  bwts: 'Yes',
  cbm: 52585.4,
  ciiRating: 'A',
  comments: [
    {
      tab: 'positionlist',
      field: 'comment',
      comment: 'xtestzz',
      createdBy: 'auth0|622b48de976a1f00695e0559',
      responsibleUser: {
        email: 'mtinternaluser_vt1@maersktankers.com',
        name: 'MT Internal User 1',
      },
      createdAt: '2024-06-06T12:35:22.809Z',
      updatedAt: '2025-02-18T08:14:30.097Z',
      hash: '63b068027eeeefce1d0a86be323da8b5f61d535d',
      updatedBy: 'auth0|660e6ab8c6fc95e032f1b2c5',
      updatedResponsibleUser: {
        email: 'accountmanager@test.dk',
        name: 'accountmanager@test.dk',
      },
    },
  ],
  completeDate: '2025-07-03T16:29:31',
  deliveryDate: '2017-02-27',
  dpp: 'No',
  dwt: '49709.00',
  flag: 'Marshall Islands',
  iceClass: 'No',
  igs: 'Yes',
  igsSupply: 'IG Generator',
  imoClass: '2',
  biofuelCapable: 'No',
  lastSire: {
    approval: 'International Marine Transport',
    inspectionDate: '2025-01-27T00:00:00.000Z',
    port: 'Dock Sud',
  },
  lastThreeCargoesInternal: {
    comment: null,
    createdAt: '2024-04-25T13:41:26.369Z',
    lastThreeCargoes: null,
    responsibleUser: {
      email: 'christian.mark@maersktankers.com',
      name: 'christian.mark@maersktankers.com',
    },
  },
  lastUpdateGmt: '2025-05-13T10:36:50',
  loa: '183.00',
  mouldedDepth: '19.10',
  nextDryDock: '2027-02-26',
  nextDryDockInternal: {
    comment: null,
    createdAt: null,
    nextDryDock: null,
    responsibleUser: null,
  },
  openDate: '2025-07-03T16:29:31',
  openPort: 'HOUSTON',
  operator: 'Neelabh Srivastav',
  pbl: '74.80',
  redeliveryDate: '2027-02-23T21:01:00.000Z',
  rejections: [],
  scrubber: 'No',
  sternLine: 'No',
  summerDraft: '13.31',
  tankCoating: null,
  usCoc: {
    issued: '2022-04-06',
    lastAnnual: '2023-05-17',
  },
  vessel: 'Cl Fugou',
  vesselCode: 'VNA8',
  vesselId: '6050cc2f5673da7ea0abaaff',
  worldArea: {
    level1: 'Americas',
    level2: 'Atlantic Basin',
    level3: 'USG-Caribs',
  },
  yearBuilt: '2017',
}

export const positionListMock = [vessel2, vessel1]
